/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:46:52
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-06-01 16:33:18
 * @FilePath: \client-h5\src\pages\bindTel\index.jsx
 */

import React, { Component } from 'react';
import {
    Form,
    Input,
    Button,
    Dialog,
    Toast,
} from 'antd-mobile';
import { getCode, register,comfirmChangePhone,changePhone } from "./services";
import {handleToast,getQueryVariable,host} from "../../utils/util";
import { getToken, } from "../../utils/api";

import './index.scss'
class BIndTel extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            renderModal: true,
            count: 60,
            liked: true,
            canLogin: false,
            tel: '',
            code: '',
            showModal:false
        }
    }
    componentDidMount() {
        if (getQueryVariable('formPage') == 'my') {
            document.title = '修改绑定手机号'
        }else{
            document.title = '账号管理与绑定'
        }
    }
    getToken = (openId)=>{
        getToken({openId}).then((res) =>{
            if (res.access_token !=='') {
                const token = res.access_token
                window.localStorage.setItem('token', token)
                window.localStorage.setItem('isLogin', 1)
                window.location.replace(host+'home')
            }
        }).catch((err) =>{
            if (err.status == '401') {
                window.location.replace(host+'bindTel?openId='+openId)

            }
        })
    }
    onFinish = (values) => {
        const {code, tel} = this.state;
        if (!code&&!tel) {
            Toast.show({
                content: '输入有误，请重新输入',
            })
            return;
        }
        if (getQueryVariable('formPage') == 'my') {
            changePhone({
                telephone: tel,
                code,
            }).then(res => {
                if (res.code == 200) {
                    handleToast('手机号修改成功')
                    setTimeout(()=>{
                        window.location.replace(host+'home')
                        this.setState({
                            code:'',
                            tel:''
                        })
                    },600)
                    
                } else  {
                    handleToast(res.message)
                } 
            })
            return;
        }
        let openId = getQueryVariable('openId')
        register({
            telephone: tel,
            smsCode:code,
            openid:openId,
        }).then(res => {
            if (res.code == 200) {
                handleToast('手机号绑定成功')
                this.getToken(openId)
            }else if (res.code == 6) {//已绑定其他微信
                this.setState({showModal:true});
            }else {
                handleToast(res.message)
            } 
        })
        
    }
    onCancle = ()=>{
        this.setState({showModal:false});
    }
    onConfirm = ()=>{
        const { tel } = this.state;
        let openId = getQueryVariable('openId');
        comfirmChangePhone({
            telephone: tel, 
            openid:openId,
        }).then(res => {
            this.setState({showModal:false});
            if (res.code == 200) {
                handleToast('手机号绑定成功')
                this.getToken(openId)
             
            } else  {
                handleToast(res.message)
            } 
        }).catch((err) =>{
            this.setState({showModal:false});
            handleToast('系统错误')
        })
    }
    renderModal = () => {
        const { showModal } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModal ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModal ? "board display" : "board"}>
                    <div className="titile"><span>提示</span></div>
                    <div className='content'>
                        <div className="text-box">
                            <text className="t_value_center">该手机号已绑定其他微信，是否更换绑定当前微信？</text>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <span  className="cancel towBtn" onClick={this.onCancle}>取消</span>
                        <span  className="towBtn" onClick={this.onConfirm}>确定</span>
                    </div>
                </div>
            </>
        )
    }
    countDown() {
        const { count } = this.state;
        if (count === 1) {
            this.setState({
                count: 60,
                liked: true,
            });
        } else {
            this.setState({
                count: count - 1,
                liked: false,
            });
            setTimeout(this.countDown.bind(this), 1000);
        }
    }
    handleClick = () => {
        const { liked,tel } = this.state;
        if (!liked) {
            return;
        }
        if (tel) {
            getCode({
                telephone: tel
            }).then(res => {
                if (res.code == 200) {
                    handleToast('验证码已发送')
                    this.countDown();
                } else if (res.code == 50) {
                    handleToast('手机号格式不正确')
                } else if (res.code == 24) {
                    handleToast('请勿频繁获取验证码')
                } 
            })
        } else {
            handleToast('手机号格式不正确')
        }
    };
    onValuesChange = (e)=>{
        if (e.tel) {
            if (e.tel.length==11) {
                this.setState({
                    tel:e.tel
                })
            }else{
                this.setState({
                    tel:''
                })
            }
        }
        
        if (e.code) {
            if (e.code.length==6) {
                this.setState({
                    code:e.code,
                })
            }else {
                this.setState({
                    code:'',
                })
            }
        }

    }
    render() {
        const {canLogin,liked,count,code,tel} = this.state;
        return (
            <div className="bindTel-container">
                {this.renderModal()}
                <Form
                    onFinish={this.onFinish}
                    footer={
                        <Button block type='submit' shape='rounded' color='primary' size='large' 
                        className ={code&&tel?'submit-btn canLogin':'submit-btn '} >
                            提交
                        </Button>
                    }
                    onValuesChange={this.onValuesChange}
                >
                    <Form.Item name='tel' >
                        <Input placeholder='请输入账号手机号' clearable type='number' />
                    </Form.Item>
                    <div className="marginBottom"></div>
                    <Form.Item
                        name = 'code'
                        extra={<Button  onClick={() => this.handleClick()} block shape='rounded' size='middle' color='primary' 
                        className = {!liked?'getCodeBtn disabled-btn':'getCodeBtn'}>
                            {
                                liked? '获取验证码': `已发送${count<10?'0'+count:count}`
                            }
                        </Button>}
                    >
                        <div className="inp">
                            <Input placeholder='请输入验证码' clearable type='number'  />
                        </div>
                    </Form.Item>
                </Form>
            </div>
        )
    }
}
export default BIndTel;

